import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useMemo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from '../pmi-select/pmi-form-control';
import { PmiSelect } from '../pmi-select';

export enum IDFlags {
  Nessuna = '0',
  Attribuzione = '1',
  Omocodice = '2',
  SenzaControllo = '3',
}

const flags = Object.freeze([
  {
    id: IDFlags.Nessuna,
    value: 'Nessuna azione',
  },
  {
    id: IDFlags.Attribuzione,
    value: 'Richiesta attribuzione',
  },
  {
    id: IDFlags.Omocodice,
    value: 'Richiesta omocodice',
  },
  {
    id: IDFlags.SenzaControllo,
    value: 'Forza mutazione senza controllo CF',
  },
]);

interface FlagValidationFiscalCodeProps {
  disabled?: boolean;
  error?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  flagsData?: Array<ItemVM>;
}

const FlagValidationFiscalCodeComponent = ({
  disabled,
  onChange,
  required,
  value,
  error,
  flagsData,
}: FlagValidationFiscalCodeProps): React.ReactElement => {
  const flagsView = useMemo(() => flagsData || flags, [flagsData, flags]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="flag-validation-label">
        {required ? 'Flag validazione codice fiscale *' : 'Flag validazione codice fiscale'}
      </InputLabel>
      <PmiSelect
        labelId="flag-validation-label"
        id="flag"
        name="flag"
        value={value}
        label={required ? 'Flag validazione codice fiscale *' : 'Flag validazione codice fiscale'}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {flagsView.map((flag: ItemVM) => (
          <MenuItem key={flag.id} value={flag.id}>
            {flag.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

FlagValidationFiscalCodeComponent.displayName = 'List Flag validation fiscal code component';

const FlagValidationFiscalCode = memo(FlagValidationFiscalCodeComponent);

export default FlagValidationFiscalCode as typeof FlagValidationFiscalCodeComponent;
